import React from "react";
import { TYPE_PC, TYPE_SP } from "../common/defines";
import { Link } from "../lib/Link";
import { getUrl } from "../lib/masterUtil";
import masterData from "../lib/masterData";
import { MasterDataReady } from "../lib/masterData/MasterDataReady";
import { DynamicContent, isVisibleContent } from "../common/DynamicContent";

export class TopBanner extends React.Component {
  render() {
    return <MasterDataReady schemaIds={["topBanners"]} render={() => {
      const topBanners = masterData.topBanners && masterData.topBanners.filter(topBanner => isVisibleContent(topBanner));
      if (topBanners && topBanners.length) {
        return (
          <div className="TopBanner">
            { topBanners.length !== 1 && <div className="BannerAnimation">
            {topBanners.map((topBanner, index) => (
            <DynamicContent
              params={topBanner}
              type={this.props.type}
              key={index}
              className={topBanners.length === 1 ? "noAnime" : ""}
              style={{
                animationDuration: topBanners.length * 6 + 's',
                animationName: 'marquee' + topBanners.length,
                animationDelay: (topBanners.length - index - 1) * -6 + 's',
              }}
            >
              </DynamicContent>))}
            </div>}
            { topBanners.length === 1 && <div>
            {topBanners.map((topBanner, index) => (
            <DynamicContent
              params={topBanner}
              type={this.props.type}
              key={index}
              className={topBanners.length === 1 ? "noAnime" : ""}
              style={{
                animationDuration: topBanners.length * 6 + 's',
                animationName: 'marquee' + topBanners.length,
                animationDelay: (topBanners.length - index - 1) * -6 + 's',
              }}
            >
              </DynamicContent>))}
            </div>}
          </div>);
      } else {
        return null;
      }
    }} loading={() => <div/>}>
    </MasterDataReady>
  }
}



// WEBPACK FOOTER //
// ./common/TopBanner.jsx